module.exports = __webpack_public_path__ + "static/Quicksand-Light-10ce81d2a0fc09f271edf43e66d80301.ttf";